import { render, staticRenderFns } from "./PendingReceivable.vue?vue&type=template&id=39da8674&scoped=true&lang=pug"
import script from "./PendingReceivable.vue?vue&type=script&lang=js"
export * from "./PendingReceivable.vue?vue&type=script&lang=js"
import style0 from "./PendingReceivable.vue?vue&type=style&index=0&id=39da8674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da8674",
  null
  
)

export default component.exports